import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
// Components
import Header from '../components/Header/Header';
import Intro from '../components/Intro/Intro';
import PowerBi from '../components/PowerBi/PowerBI';
import Profile from '../components/Profile/Profile';
import { RoutesAdmin } from './RoutesAdmin';
import { RoutesOwner } from './RoutesOwner';
import { RoutesNotification } from './RoutesNotification';
import { RoutesCreateObra } from './RoutesCreateObra';
import { RoutesUpdateData } from './RoutesUpdateData';
import { RoutesOwnerSpecialist } from './RoutesOwnerSpecialist';
import Login from '../components/Login/Login';
import { EventType } from '@azure/msal-browser';
import { b2cPolicies } from '../services/auth/authProvider';
import { loginRequest } from '../services/auth/authProvider';
import AxiosInterceptors from '../axios.interceptors';
import Swal from 'sweetalert2';
import { Loader } from '../components/shared/loader/Loader';
import RoleAuthenticator from '../components/role-authenticator/roleAuthenticator.component';

export default function Router() {
    const { instance } = useMsal();
    const [, setChanged] = useState<boolean>(false);
    const [existMe, setExistMe] = useState(true);
    const [notMe, setNotMe] = useState(true);
    const [token, setToken] = useState('');

    const changeNotifications = () => {
        setChanged(true);
        setTimeout(() => {
            setChanged(false);
        }, 500);
    };

    useEffect(() => {
        console.log('Last updated: 02/11/2023 15:46');
        setExistMe(false);
        setNotMe(false);
        const callbackId = instance.addEventCallback((event: any) => {
            if (event.eventType === EventType.HANDLE_REDIRECT_START) {
                if ('Token' in localStorage) {
                    setToken(localStorage.getItem('Token')!);
                }
            }
            if (
                (event.eventType === EventType.LOGIN_SUCCESS ||
                    event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
                event.payload.account
            ) {
                /**
                 * For the purpose of setting an active account for UI update, we want to consider only the auth
                 * response resulting from SUSI flow. "tfp" claim in the id token tells us the policy (NOTE: legacy
                 * policies may use "acr" instead of "tfp"). To learn more about B2C tokens, visit:
                 * https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
                 */
                if (event.payload.idTokenClaims['acr'] === b2cPolicies.names.editProfile) {
                    // retrieve the account from initial sing-in to the app
                    const originalSignInAccount = instance
                        .getAllAccounts()
                        .find(
                            (account: any) =>
                                account.idTokenClaims!.sub === event.payload.idTokenClaims.sub &&
                                account.idTokenClaims!['acr'] === b2cPolicies.names.signUpSignIn
                        );

                    if (originalSignInAccount && originalSignInAccount.idToken) {
                        setToken(
                            event.payload != null && event.payload.accessToken
                                ? event.payload.accessToken
                                : originalSignInAccount.idToken
                        );
                    }

                    let signUpSignInFlowRequest: any = {
                        authority: b2cPolicies.authorities.signUpSignIn.authority,
                        account: originalSignInAccount,
                        ...loginRequest,
                    };

                    // silently login again with the signUpSignIn policy
                    instance.ssoSilent(signUpSignInFlowRequest);
                }
            }

            if (event.eventType === EventType.SSO_SILENT_SUCCESS && event.payload.account) {
                // setStatus('ssoSilent success');
            }
        });

        return () => {
            if (callbackId) {
                instance.removeEventCallback(callbackId);
            }
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!token) return;
        AxiosInterceptors(token);
        setExistMe(true);
        setNotMe(true);
        getUser();
        localStorage.setItem('Token', token);
        // eslint-disable-next-line
    }, [token]);

    const getUser = () => {
        const userLog = instance.getActiveAccount();
        if (userLog) {
            localStorage.setItem('currentUsr', JSON.stringify(userLog));
            setExistMe(false);
            setNotMe(false);
            RoleAuthenticator(userLog);
        } else {
            setExistMe(false);
            Swal.fire({
                title: 'Acceso Denegado',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                },
            }).then((result: any) => {
                if (result.dismiss === Swal.DismissReason.timer) {
                    localStorage.clear();
                    instance.logoutRedirect();
                }
            });
        }
        // usersService
        //     .getMe()
        //     .then(({ data }) => {
        //         const currentUsr = data;
        //         localStorage.setItem('currentUsr', JSON.stringify(currentUsr));
        //         setExistMe(false);
        //         setNotMe(false);
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //         setExistMe(false);
        //         Swal.fire({
        //             title: 'Acceso Denegado',
        //             timer: 2000,
        //             timerProgressBar: true,
        //             didOpen: () => {
        //                 Swal.showLoading();
        //             },
        //         }).then((result: any) => {
        //             if (result.dismiss === Swal.DismissReason.timer) {
        //                 localStorage.clear();
        //                 instance.logoutRedirect();
        //             }
        //         });
        //     });
    };
    // const setInitRole = (role: RoleLocal) => {
    //     setRole(role);
    // }

    return (
        <div>
            {existMe && notMe ? (
                <Loader />
            ) : (
                <>
                    {!notMe && (
                        <>
                            <AuthenticatedTemplate>
                                <Header setMe={setExistMe} />
                                <Routes>
                                    <Route
                                        path='home'
                                        element={
                                            <>
                                                <Intro />
                                                <PowerBi />
                                            </>
                                        }
                                    />
                                    <Route path='update-data/*' element={<RoutesUpdateData />} />
                                    <Route path='profile' element={<Profile />} />
                                    <Route
                                        path='admin-users/*'
                                        element={
                                            <RoutesOwner>
                                                <RoutesAdmin
                                                    changeNotifications={changeNotifications}
                                                />
                                            </RoutesOwner>
                                        }
                                    />
                                    <Route
                                        path='notifications/*'
                                        element={
                                            <RoutesOwnerSpecialist>
                                                <RoutesNotification
                                                    changeNotifications={changeNotifications}
                                                />
                                            </RoutesOwnerSpecialist>
                                        }
                                    />
                                    <Route
                                        path='create-program/*'
                                        element={<RoutesCreateObra isUpdated={true} />}
                                    />
                                    <Route path='*' element={<Navigate to='/home' />} />

                                    <Route path='/' element={<Navigate to='/home' />} />
                                </Routes>
                            </AuthenticatedTemplate>
                            <UnauthenticatedTemplate>
                                <Login />
                            </UnauthenticatedTemplate>
                        </>
                    )}
                </>
            )}
        </div>
    );
}
